import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const getToken = () => localStorage.getItem("ld_token");
export const setToken = (t) => localStorage.setItem("ld_token", t);
export const clearToken = () => localStorage.removeItem("ld_token");

export const authHeaders = () => ({
  headers: { Authorization: `Bearer ${getToken()}` },
});

export const imgUrl = (img) =>
  !img ? "" : img.startsWith("http") ? img : `${API}/files/${img}`;

export function formatApiError(error) {
  const detail = error?.response?.data?.detail;
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => e?.msg || JSON.stringify(e)).join(" ");
  return error?.message || "Error inesperado";
}

export default axios;
